import { Box, Button } from '@betterment/samba-react';

import { DateRangeOption } from '../../../graphql/schema';

export const dateRangeOptions = [
  { label: 'All', value: DateRangeOption.AllTime, ariaLabel: 'All time', longLabel: 'all time' },
  { label: '5Y', value: DateRangeOption.PastFiveYears, ariaLabel: 'Past 5 years', longLabel: 'past 5 years' },
  { label: '3Y', value: DateRangeOption.PastThreeYears, ariaLabel: 'Past 3 years', longLabel: 'past 3 years' },
  { label: '1Y', value: DateRangeOption.PastYear, ariaLabel: 'Past year', longLabel: 'past year' },
  { label: 'YTD', value: DateRangeOption.YearToDate, ariaLabel: 'Year to date', longLabel: 'year to date' },
  { label: '3M', value: DateRangeOption.PastThreeMonths, ariaLabel: 'Past 3 months', longLabel: 'past 3 months' },
  { label: '1M', value: DateRangeOption.PastMonth, ariaLabel: 'Past month', longLabel: 'past month' },
];

export const DateRangeFilter: React.FC<{
  onChange: (option: DateRangeOption) => void;
  selected: DateRangeOption;
}> = ({ onChange, selected }) => {
  return (
    <Box role="radiogroup" aria-label="Date range filter" css={{ display: 'flex', gap: 'space.100' }}>
      {dateRangeOptions.map(option => (
        <Button
          key={option.value}
          onClick={() => onChange(option.value)}
          variant={selected === option.value ? 'solidPrimary' : 'ghostSecondary'}
          spacing="compact"
          role="radio"
          aria-checked={selected === option.value}
          aria-label={option.ariaLabel}
          css={{
            minWidth: 'size.500',
            borderRadius: '20px', // pill-shaped buttons
          }}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
};
